const _ = require('lib/underscore')
const Marionette = require('lib/marionette')
const FacebookController = require('./facebook_auth')
// const TwitterController = require('./twitter_auth')
const GoogleController = require('./google_auth')

const log = require('log').create('social_auth') // eslint-disable-line

const SocialAuth = Marionette.MnObject.extend({

    initialize(options) {

        _.defaults(options, {
            facebook: true,
            // twitter: true,
            google: true,
        })

        if (options.facebook) {
            this.facebook_controller = new FacebookController()
        }

        // if (options.twitter) {
        //     this.twitter_controller = new TwitterController()
        // }

        if (options.google) {
            this.google_controller = new GoogleController({
                element: options.google_button,
            })
        }

    },

})

module.exports = SocialAuth
